export enum LogLevel {
    Verbose,
    Info,
    Event,
    Warning,
    Error,
    Critical,
}
